import {
  Bike, Wrench, Hammer, Calendar, Gauge, Zap, User, Fuel, Tag, Package,
  Car, ShieldCheck, Layers, Ruler,
} from "lucide-react";

export const V_ICONS = {
  Bike, Wrench, Hammer, Calendar, Gauge, Zap, User, Fuel, Tag, Package,
  Car, ShieldCheck, Layers, Ruler,
};
